import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';

import _image from "./../../image/image.react.js";

var Image = _image.applyDecls();

import "./../../image/image.css";
import "./../__icon-file/attach__icon-file.css";
import "./../__reset/attach__reset.css";
import "./../../../desktop.blocks/attach/__reset/attach__reset.css";

var i18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./../attach.i18n/ru'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./../attach.i18n/en'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./../attach.i18n/be'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./../attach.i18n/id'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./../attach.i18n/kk'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./../attach.i18n/tr'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./../attach.i18n/tt'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./../attach.i18n/uk'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uz' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uz' : 'en' === 'uz') {
        return core().decl(require('./../attach.i18n/uz'))('attach');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
    }

    return function () {};
}();

export default decl({
    block: 'attach',
    elem: 'holder',
    tag: 'span',
    mods: function mods(_ref) {
        var hasFile = _ref.hasFile,
            ext = _ref.ext;

        return {
            state: hasFile || 'hidden',
            file: hasFile && ext
        };
    },

    attrs: { 'aria-hidden': 'true' },
    content: function content(_ref2) {
        var id = _ref2.id,
            textWidth = _ref2.textWidth,
            hasFile = _ref2.hasFile,
            children = _ref2.children;

        var holderText = children || i18n('no-file');
        var style = {};

        if (hasFile && textWidth) {
            style = { width: textWidth + 'px' };
        }

        return [React.createElement(Image, { mix: { block: 'attach', elem: 'icon-file' }, key: 'icon' }), React.createElement(
            'label',
            {
                style: style,
                className: 'attach__text',
                htmlFor: id, key: 'label' },
            holderText
        ), React.createElement(Image, { mix: { block: 'attach', elem: 'reset' }, key: 'reset', onClick: this.props.onResetClick })];
    }
});